import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-person-icon',
},
  __name: 'person-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 24 24",
      fill: __props.fill
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
      }, null, -1)
    ]))], 8, _hoisted_2))
  ]))
}
}

})